import api from '../../../services/api';
import buildQuery from 'odata-query'

export const IDCARDS_URL = '/idcard'
export const STANDBY_URL = '/StandardStandBy'
export const TRAINING_URL = '/training'

// Pega todas as IDCARDS
export function getAllLpp() {
    return api.get(IDCARDS_URL)
}

// Retorna os dados por filtro
export function getByFilters ( queryParams ) {
    return api.get(`${IDCARDS_URL}/odata${queryParams}`)
}

/**
 * Retorna os dados por odata
 * 
 * @param {Partial<import('odata-query').QueryOptions<any>>} odata 
 * @returns {ApiOdataResponse<IdCard>}
 */
export function fetchDataByOdata ( odata ) {
    return api.get(`${IDCARDS_URL}/odata${buildQuery(odata)}`)
}

// Retorna os dados por filtro
export function fetchDataViewStandBy(id) {
    return fetchData(id, STANDBY_URL)
}

// Retorna a view
export function fetchDataViewIDCARDS(id, trainingData = true) {
    return fetchData(id, IDCARDS_URL, trainingData )
}

// Retorna a view
export function fetchDataById(id) {
    return api.get(`${IDCARDS_URL}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        select: ['identifier']
    }))
}

export function fetchData(id, url, trainingData = false) {
    if (trainingData) {
        return api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            expand: {
                steps: true,
                trainingUsers: {
                    select: ['userId'],
                    expand: {
                        user: {
                            select: ['id', 'name', 'sap'],
                            expand: [
                                'companyRole',
                                'deparment'
                            ]
                        }
                    }
                },
                structure: {
                    select: ['name'],
                    expand: {
                        father: {
                            select: ['name']
                        }
                    }
                },
                product: {
                    select: ['*']
                },
                defectType: {
                    select: ['*']
                },
                defectCategory: {
                    select: ['*']
                }
            }
        }))
    }
    else {
        return api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            expand: {
                steps: true,                
                structure: {
                    select: ['name'],
                    expand: {
                        father: {
                            select: ['name']
                        }
                    }
                },
                product: {
                    select: ['*']
                },
                defectType: {
                    select: ['*']
                },
                defectCategory: {
                    select: ['*']
                }
            }
        }))
    }
    
}

export function fetchTraining(id, version) {
    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id),
            version: version
        },
        expand: {
            users: {
                expand: {
                    user: {
                        select: ['id', 'name', 'sap'],
                        expand: [
                            'companyRole',
                            'deparment'
                        ]                        
                    }
                }
            }
        },
        count: true,
    }))
}




//Salva a IDCARD
export function updateIdcard(lpp) {
    return api.put(lpp);
}

export function getIdcardStandby(queryParams) {
    return api.get('/StandardStandBy/odata/' + buildQuery(queryParams));
}